import React, { useCallback, useEffect, useRef, useState } from "react";
import backicon from '../../../../../Assets/icons/backIcon.svg';
import "./index.scss";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import ReactSignatureCanvas from "react-signature-canvas";
import Carlogo from "../../../../../Assets/images/carImage.png";
import { Button, Modal } from 'react-bootstrap';
import { color } from "chart.js/helpers";
import { TbBackground } from "react-icons/tb";
import axiosInstance from "../../../../../http.common";
import uploadIcon from "../../../../../Assets/icons/uploadicon.svg";
import Switch from "react-switch";
import CustomTable from "../../../../customComponents/CustomTable";
import { isVisible } from "@testing-library/user-event/dist/utils";

//./../../../Assets/icons/uploadicon.svg
const AddSurvayCard = () => {
    const [formData, setFormData] = useState({ Trans_Date: new Date() });
    const token = localStorage.getItem("authToken");
    const businessPartnerId = localStorage.getItem("business_partner_id")
    const [activeSection, setActiveSection] = useState('Customer');
    const [isLoading, setIsLoading] = useState(false)
    const [validationErrors, setValidationErrors] = useState({});
    const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
    const [signatureModel, setSignatureModel] = useState(false);
    const [jobCardType, setJobCardType] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [VeriantListShow, setVeriantListShow] = useState(false);
    const [veriantListData, setVeriantListData] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);
    const sigCanvas = useRef();
    // const [isDocumentFormSubmitted, setIsDocumentFormSubmitted] = useState(false);
    const navigate = useNavigate();


    const fetchJobCardList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/jobtype', {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            if (response?.status) {
                setJobCardType(response?.data?.data?.data?.map((jobTypeDetails, index) => (
                    {
                        label: jobTypeDetails?.name,
                        value: jobTypeDetails?.id,
                    }
                )
                ))
            }
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const fetchCustomerList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getcustomerdetails',
                {
                    business_partner_id: businessPartnerId==0?1:businessPartnerId,
                    "FilterId": 35,
                    "FilterString": "9586904950",
                    "Type": "AllotedCustomer"
                }, {

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response?.status) {
                setCustomerList(response?.data?.data?.map((customerJobList, index) => (
                    {
                        label: customerJobList?.name,
                        value: customerJobList?.id,
                    }
                )
                ))
            }
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const fetchSupervisorList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getcustomerdetails',
                {
                    business_partner_id: businessPartnerId==0?1:businessPartnerId,
                    "FilterId": null,
                    "FilterString": null,
                    "Type": "Supervisor"
                }, {

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response?.status) {
                setSupervisorList(response?.data?.data?.map((customerJobList, index) => (
                    {
                        label: customerJobList?.name,
                        value: customerJobList?.id,
                    }
                )))
                // setVeriantList(response?.data);
            }
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const handleFormSubmit = async (data) => {
        console.log("Form Data:", data);
        const payload = {
            business_partner_id:businessPartnerId==0?1:businessPartnerId ,
            quotation_id: 1,
            job_card_no: null,
            transaction_date: "2024-07-22",
            job_type_id: data?.Job_Type,
            customer_id: data?.Customer_Name,
            contact_no: data?.MobileNo,
            registration_no: data?.RegNo,
            chassis_no: data?.chassisno,
            variant_id: data?.variant_id,
            make_id: data?.make_id,
            model_id: data?.model_id,
            warranty_startdate: data?.Warranty_Start_Date,
            warranty_period: 255,
            // data?.Warranty_Period,
            warranty_enddate: data?.Warranty_End_Date,
            extended_warranty: data?.ExtendedWarranty,
            location: null,
            complaint: data?.Complain,
            labour_charges: "700.00",
            is_job_cardsubmitted: null,
            filename: null,
            survey_filename: null,
            survey_path: null,
            signature_filename: null,
            signature_path: null,
            engine_no: data?.EngineNo,
            extwarranty_startdate: null,
            extwarranty_enddate: null,
            delivery_remark: null,
            delivery_date: null,
            allissue_resolve: null,
            invoice_date: null,
            amount_received: null,
            invoice_no: null,
            solved_remarks: null,
            //data?.Complain,
            solved_date: null,
            solved: null,
            fastclose_date: null,
            fastclose: null,
            service_invoiceno: null,
            chargeable_amount: null,
            job_estimate_amount: data?.JobEstimateAmount,
            allocation_date: "2024-07-05",
            supervisor_id: data?.Supervisor,
            technician_id: null,
            invoice_id: data?.invoice_id,
            status: 1
        }
        try {
            const response = await axiosInstance.post('/jobcard/create',
                payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            console.log('response', response);
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }

    };


    useEffect(() => {
        Variantlist();
    }, [formData?.Customer_Name])

    const Variantlist = async () => {
        try {
            const response = await axiosInstance.post('/jobcard/listdynamicjobcard',
                {
                    business_partner_id:businessPartnerId==0?1:businessPartnerId ,

                    "FilterId": formData?.Customer_Name,
                    "FilterString": null,
                    "FilterString1": null,
                    "Type": "JobCardVariantSelection"
                }, {

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });
            console.log('responseqweqweqwee11', response?.data?.data)
            if (response?.status) {
                if (response?.data?.data?.length > 0) {
                    setVeriantListData(response?.data?.data || []);
                    setVeriantListShow(true);
                }
            }
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };


    useEffect(() => {
        fetchJobCardList();
        fetchCustomerList();
        fetchSupervisorList();
    }, []);

    const backNavigate = () => {
        navigate("/admin/manage-onboard/onboard")
    }



    const handleClicableRow = (row) => {
        setFormData((pre) => ({
            ...pre,
            MobileNo: row?.ContactNo,
            JobNo: row?.JobNo,
            chassiNo: row?.chassisno,
            Model: row?.ModelName,
            Make: row?.MakeName,
            RegNo: row?.registrationno,
            Warranty_Period: row?.WarrantyPeriod,
            Product: row?.product_name,
            SubProduct: row?.subproduct_name,
            Variant: row?.VariantName,
            ChassisNo: row?.chassisno,
            EngineNo: row?.engineno,
            Extended_Warranty: row?.ExtendedWarranty,
            Warranty_Start_Date: row?.WarrantyStartDate,
            Warranty_End_Date: row?.WarrantyEndDate,
            chassiNo: row?.chassisno,
            variant_id: row?.variant_id,
            make_id: row?.make_id,
            model_id: row?.model_id,
            Color: row?.color_name,
            fualType: row?.fuel_type_name,
            invoice_id: row?.invoice_id,

        }))
        setVeriantListShow(false)
    }

    const survayList = [
        {
            id: 1,
            title: 'Head Lamp',
            isSwich: false
        },

        {
            id: 1,
            title: 'Indicator Light(Lt)',
            isSwich: true
        },
        {
            id: 1,
            title: 'Right pillar Rear (c)',
            isSwich: true
        },
        {
            id: 1,
            title: 'Front Panel',
            isSwich: true
        },

        {
            id: 1,
            title: 'Left Apron',
            isSwich: true
        },
        {
            id: 1,
            title: 'Right Qtr',
            isSwich: true
        },
        {
            id: 1,
            title: 'Left Piller (center)',
            isSwich: true
        },
        {
            id: 1,
            title: 'Left Running Bord',
            isSwich: true
        },
        {
            id: 1,
            title: 'Head Lamp (Rt)',
            isSwich: true
        },
        {
            id: 1,
            title: 'Boot',
            isSwich: true
        },
        {
            id: 1,
            title: 'Tail Lamp(lt)',
            isSwich: true
        },
        {
            id: 1,
            title: 'indicator light(Rt)',
            isSwich: true
        },
        {
            id: 1,
            title: 'Grill',
            isSwich: true
        },
        {
            id: 1,
            title: 'Right Font Door',
            isSwich: true
        },
        {
            id: 1,
            title: 'Tail Lamp (Rt)',
            isSwich: true
        },
    ]

    const handleFileDrop = (e, name) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        // setFormData({ ...formData, [name]: file });
        // setFileNames({ ...fileNames, [name]: file.name });
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <ToastContainer />
            <div className="backbutton mt-2 mb-2">
                <img onClick={backNavigate} src={backicon} alt="back" />
                <span className="backbtntitle">Add Survay  Card</span>
            </div>
            <div >
                <div className="carImgDiv mt-5  mb-3">
                    <img src={Carlogo} style={{ width: '70%', backgroundColor: '#e2e2e2', }} />
                </div>
                <div className="divboder" />
                <div className=" col-xl-12 col-lg-12 selectedOptionDiv row ">
                    {(survayList || []).map((itemSurvay) => (
                        <div className="col-xl-4 col-lg-4 selectedSubOptionDiv  ">
                            <div className="col-xl-12 col-lg-12 row">
                                <div className="col-xl-6 col-lg-8 mt-3 ">
                                    <span>{itemSurvay?.title || '-'}</span>
                                </div>
                                <div className="col-xl-6  col-lg-8 mt-3 ">
                                    <Switch
                                        checked={itemSurvay?.isSwich}
                                        onChange={(checked) =>
                                            console.log('qweqrtwt')
                                        }
                                        title={'safe'}
                                        className="react-switch"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="col-xl-12 col-lg-12 fileDiv row ">
                    <div
                        //key={field.name} 
                        className={`form-group`}
                    >
                        {/* //${additionalClass} */}
                        <div
                            className="file-drop-area"
                            // onDrop={(e) => handleFileDrop(e, field.name)}
                            onDragOver={handleDragOver}
                        >
                            <div className="custom-file-upload">
                                <input
                                    type="file"
                                    // name={field.name}
                                    // id={field.name}
                                    // onChange={(e) =>
                                    //  // handleChange(field.name, e.target.files[0])
                                    // }
                                    className="file-input"
                                    style={{ display: "none" }}
                                />
                                <label
                                    //   htmlFor={field.name} 
                                    className="custom-file-label">
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",

                                        }}
                                    >
                                        <img src={uploadIcon} />
                                        {
                                            "Drag and drop a file or click to upload"}
                                    </div>
                                </label>
                            </div>
                        </div>

                        {/* {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )} */}
                        {/* {formData[field.name] ? (
                        <div style={{ marginTop: "10px" }}>
                            Image uploaded successfully
                        </div>
                         ) : null} */}

                    </div>
                    <div className='totalvaluescontainer col-xl-8 col-lg-12 '>
                        <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                            Add New Parts
                        </button>
                        <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                            Edit
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddSurvayCard;
